import { isTop } from './isTop';
import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const agentOffersLink: TComputedPropMapper<string | undefined> = (props, ctx) => {
  const { user, dealType, cianUserId, offerType } = props.offer;
  const userId = user?.cianUserId || cianUserId || undefined;
  const userIdForLink = user?.masterAgent?.id || userId;
  const userIdQuery = userIdForLink ? `id_user=${userIdForLink}&` : '';

  const offerTypeQuery = offerType === 'commercial' ? 'offer_type=office' : `${offerType}=yes`;
  const url = `/cat.php?${userIdQuery}deal_type=${dealType}&${offerTypeQuery}&engine_version=2`;

  return isTop(props, ctx) ? url : undefined;
};
